import React from 'react';

import { User } from '@modules/core/models';
import { UserMenu } from '@modules/core/components';

import './Header.scss';

interface Props {
    user: User;
    isSuperUser?: boolean;
}

export const Header = (props: Props) => {
    const { user } = props;

    const title = 'Products';

    return (
        <div className="header" qa-id="header">
            <div className="header-top">
                <div className="user-management-naming">
                    <div>
                        Wärtsilä
                        <span> {title}</span>
                    </div>
                </div>
                <UserMenu user={user} />
            </div>
        </div>
    );
};
